/**
 * Pair With — Carousel + Split Pane
 * Handles:
 *  - Carousel arrow navigation (prev/next)
 *  - Add to cart from carousel cards
 *  - Click product to open split pane
 *  - Add to cart from pane → auto-suggest next product
 *  - Cart bar at top showing total + checkout link
 */
(function() {
  'use strict';

  var carousel = document.getElementById('PairWithCarousel');
  var pane = document.getElementById('PairPane');
  var backdrop = document.getElementById('PairPaneBackdrop');
  var cartBar = document.getElementById('PairCartBar');
  if (!carousel) return;

  var cards = carousel.querySelectorAll('.PairWith__Item');
  var prevArrow = document.querySelector('[data-pair-arrow="prev"]');
  var nextArrow = document.querySelector('[data-pair-arrow="next"]');

  // Pane elements
  var paneTitle = pane ? pane.querySelector('[data-pane-title]') : null;
  var paneBody = pane ? pane.querySelector('.PairPane__Body') : null;
  var paneAddBtn = pane ? pane.querySelector('[data-pane-add]') : null;
  var paneClose = pane ? pane.querySelector('[data-pane-close]') : null;
  var paneToast = pane ? pane.querySelector('[data-pane-toast]') : null;

  var currentPaneHandle = null;
  var currentPaneVariantId = null;
  var allPairProducts = [];

  // Gather product data from cards
  cards.forEach(function(card) {
    allPairProducts.push({
      handle: card.getAttribute('data-pair-handle'),
      variantId: card.getAttribute('data-pair-variant-id'),
      title: card.getAttribute('data-pair-title'),
      price: card.getAttribute('data-pair-price'),
      image: card.getAttribute('data-pair-image')
    });
  });

  // === CART STATE (which pair variants are already in the cart) ===
  var cartVariantIds = {};

  function isInCart(variantId) {
    return !!cartVariantIds[String(variantId)];
  }

  function loadCartState() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cartVariantIds = {};
        (cart.items || []).forEach(function(it) {
          cartVariantIds[String(it.variant_id)] = true;
        });
        return cart;
      })
      .catch(function() { return null; });
  }

  // Refresh the live card list + arrows; hide the whole block when empty.
  function refreshCardsState() {
    cards = carousel.querySelectorAll('.PairWith__Item');
    updateArrows();
    if (cards.length === 0) {
      var wrap = carousel.closest('.PairWith');
      if (wrap) wrap.style.display = 'none';
    }
  }

  // Animate a card out, then drop it so the next item slides into view.
  function removeCard(card) {
    if (!card || !card.parentNode) return;
    card.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
    card.style.opacity = '0';
    card.style.transform = 'scale(0.92)';
    setTimeout(function() {
      if (card.parentNode) card.parentNode.removeChild(card);
      refreshCardsState();
    }, 300);
  }

  function removeCardForVariant(variantId) {
    if (!variantId) return;
    var card = carousel.querySelector('.PairWith__Item[data-pair-variant-id="' + variantId + '"]');
    if (card) removeCard(card);
  }

  // Pane footer button state helpers.
  function setPaneAdded() {
    if (!paneAddBtn) return;
    paneAddBtn.textContent = 'ADDED \u2713';
    paneAddBtn.disabled = true;
    paneAddBtn.classList.add('is-added');
  }
  function setPaneAddable() {
    if (!paneAddBtn) return;
    paneAddBtn.textContent = 'ADD TO CART';
    paneAddBtn.disabled = false;
    paneAddBtn.classList.remove('is-added');
  }
  function updatePaneAddBtnState() {
    if (isInCart(currentPaneVariantId)) setPaneAdded();
    else setPaneAddable();
  }

  // On load, drop any pair items already sitting in the cart.
  loadCartState().then(function() {
    cards.forEach(function(card) {
      if (isInCart(card.getAttribute('data-pair-variant-id'))) {
        if (card.parentNode) card.parentNode.removeChild(card);
      }
    });
    refreshCardsState();
  });

  // === CAROUSEL ARROWS ===
  function updateArrows() {
    if (!prevArrow || !nextArrow) return;
    var scrollLeft = carousel.scrollLeft;
    var maxScroll = carousel.scrollWidth - carousel.clientWidth;
    prevArrow.disabled = scrollLeft < 10;
    nextArrow.disabled = scrollLeft >= maxScroll - 10;
  }

  if (prevArrow) {
    prevArrow.addEventListener('click', function() {
      var cardWidth = cards[0] ? (cards[0].offsetWidth + 10) : carousel.clientWidth;
      carousel.scrollBy({ left: -cardWidth, behavior: 'smooth' });
    });
  }
  if (nextArrow) {
    nextArrow.addEventListener('click', function() {
      var cardWidth = cards[0] ? (cards[0].offsetWidth + 10) : carousel.clientWidth;
      carousel.scrollBy({ left: cardWidth, behavior: 'smooth' });
    });
  }

  carousel.addEventListener('scroll', updateArrows);
  updateArrows();

  // === ADD TO CART (from carousel cards) ===
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-pairwith-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.getAttribute('data-pairwith-add');
    if (!variantId) return;

    var original = btn.textContent;
    btn.textContent = 'Added ✓';
    btn.disabled = true;

    addToCart(variantId).then(function() {
      // Confirm briefly, then remove this card so the next one slides into view.
      var card = btn.closest('.PairWith__Item');
      setTimeout(function() { removeCard(card); }, 700);
    }).catch(function() {
      btn.textContent = 'Error';
      setTimeout(function() {
        btn.disabled = false;
        btn.textContent = original;
      }, 1500);
    });
  });

  // === OPEN SPLIT PANE (click product image or name) ===
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-pair-view]');
    if (!trigger) return;
    e.preventDefault();
    var handle = trigger.getAttribute('data-pair-view');
    if (handle) openPane(handle);
  });

  function openPane(handle) {
    if (!pane) return;
    pane.classList.add('open');
    if (backdrop) backdrop.classList.add('open');
    currentPaneHandle = handle;

    // Find product data
    var prod = allPairProducts.find(function(p) { return p.handle === handle; });
    if (paneTitle) paneTitle.textContent = prod ? prod.title : handle.replace(/-/g, ' ');

    // Show loading
    paneBody.innerHTML = '<div class="PairPane__Toast" data-pane-toast><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg><span>Added to cart</span></div><div class="PairPane__Loading"><div class="PairPane__Spinner"></div></div>';
    if (paneAddBtn) {
      paneAddBtn.disabled = true;
      paneAddBtn.textContent = 'ADD TO CART';
      paneAddBtn.classList.remove('is-added');
    }

    // Fetch full product data
    fetch('/products/' + encodeURIComponent(handle) + '.json')
      .then(function(r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function(data) {
        var product = data.product;
        currentPaneVariantId = product.variants[0] ? product.variants[0].id : null;
        renderPaneProduct(product);
        updatePaneAddBtnState();
      })
      .catch(function() {
        // Fallback: use local data
        if (prod) {
          currentPaneVariantId = prod.variantId;
          paneBody.innerHTML = '<div class="PairPane__Toast" data-pane-toast><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg><span>Added to cart</span></div>' +
            (prod.image ? '<img class="PairPane__Image" src="' + escapeHtml(prod.image) + '" alt="' + escapeHtml(prod.title) + '">' : '') +
            '<div class="PairPane__Detail"><div class="PairPane__ProdName">' + escapeHtml(prod.title) + '</div><div class="PairPane__PriceText">' + escapeHtml(prod.price) + '</div></div>';
          updatePaneAddBtnState();
        } else {
          paneBody.innerHTML = '<div style="padding:40px 16px;text-align:center;color:#888;font-size:13px;">Could not load product.</div>';
        }
      });
  }

  function renderPaneProduct(product) {
    var images = product.images || [];
    var variant = product.variants[0];
    var price = variant ? ('$' + parseFloat(variant.price).toFixed(2)) : '';
    var desc = product.body_html || '';

    // Sanitize description (strip scripts)
    var tmp = document.createElement('div');
    tmp.innerHTML = desc;
    tmp.querySelectorAll('script,iframe,object,embed').forEach(function(el) { el.remove(); });
    desc = tmp.innerHTML;

    var html = '<div class="PairPane__Toast" data-pane-toast><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg><span>Added to cart</span></div>';

    // Image gallery
    if (images.length > 0) {
      html += '<div class="PairPane__Gallery">';
      html += '<div class="PairPane__GalleryTrack">';
      images.forEach(function(img, i) {
        html += '<div class="PairPane__GallerySlide" data-slide="' + i + '">';
        html += '<img src="' + escapeHtml(img.src) + '" alt="' + escapeHtml(product.title) + ' - image ' + (i+1) + '" class="PairPane__GalleryImg" data-zoom-src="' + escapeHtml(img.src) + '">';
        html += '</div>';
      });
      html += '</div>';
      if (images.length > 1) {
        html += '<button type="button" class="PairPane__GalleryArrow PairPane__GalleryArrow--prev" data-gallery-prev aria-label="Previous image"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg></button>';
        html += '<button type="button" class="PairPane__GalleryArrow PairPane__GalleryArrow--next" data-gallery-next aria-label="Next image"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 6 15 12 9 18"/></svg></button>';
        html += '<div class="PairPane__GalleryDots">';
        images.forEach(function(_, i) {
          html += '<span class="PairPane__GalleryDot' + (i === 0 ? ' active' : '') + '" data-dot="' + i + '"></span>';
        });
        html += '</div>';
      }
      html += '</div>';
    }

    html += '<div class="PairPane__Detail">';
    html += '<div class="PairPane__ProdName">' + escapeHtml(product.title) + '</div>';
    html += '<div class="PairPane__PriceText">' + price + '</div>';
    if (desc) html += '<div class="PairPane__Desc">' + desc + '</div>';
    html += '</div>';

    paneBody.innerHTML = html;
    paneToast = pane.querySelector('[data-pane-toast]');

    // Init gallery
    initPaneGallery();
  }

  function initPaneGallery() {
    var gallery = paneBody.querySelector('.PairPane__Gallery');
    if (!gallery) return;

    var track = gallery.querySelector('.PairPane__GalleryTrack');
    var slides = gallery.querySelectorAll('.PairPane__GallerySlide');
    var dots = gallery.querySelectorAll('.PairPane__GalleryDot');
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    var currentSlide = 0;

    function goToSlide(idx) {
      if (idx < 0) idx = 0;
      if (idx >= slides.length) idx = slides.length - 1;
      currentSlide = idx;
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      dots.forEach(function(d, i) {
        d.classList.toggle('active', i === idx);
      });
      if (prevBtn) prevBtn.style.display = idx === 0 ? 'none' : '';
      if (nextBtn) nextBtn.style.display = idx >= slides.length - 1 ? 'none' : '';
    }

    if (prevBtn) prevBtn.addEventListener('click', function(e) { e.stopPropagation(); goToSlide(currentSlide - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function(e) { e.stopPropagation(); goToSlide(currentSlide + 1); });
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() { goToSlide(parseInt(dot.getAttribute('data-dot'))); });
    });

    // Swipe support
    var startX = 0, deltaX = 0, swiping = false;
    track.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      deltaX = 0;
      swiping = true;
    }, { passive: true });
    track.addEventListener('touchmove', function(e) {
      if (!swiping) return;
      deltaX = e.touches[0].clientX - startX;
    }, { passive: true });
    track.addEventListener('touchend', function() {
      if (!swiping) return;
      swiping = false;
      if (Math.abs(deltaX) > 40) {
        if (deltaX < 0) goToSlide(currentSlide + 1);
        else goToSlide(currentSlide - 1);
      }
    });

    // Tap to zoom
    slides.forEach(function(slide) {
      slide.addEventListener('click', function() {
        var img = slide.querySelector('img');
        if (!img) return;
        openZoom(img.getAttribute('data-zoom-src') || img.src);
      });
    });

    goToSlide(0);
  }

  function openZoom(src) {
    var overlay = document.createElement('div');
    overlay.className = 'PairPane__ZoomOverlay';
    overlay.innerHTML = '<img src="' + escapeHtml(src) + '" class="PairPane__ZoomImg"><button type="button" class="PairPane__ZoomClose" aria-label="Close zoom">&times;</button>';
    document.body.appendChild(overlay);

    // Animate in
    requestAnimationFrame(function() { overlay.classList.add('open'); });

    function closeZoom() {
      overlay.classList.remove('open');
      setTimeout(function() { overlay.remove(); }, 250);
    }

    overlay.querySelector('.PairPane__ZoomClose').addEventListener('click', closeZoom);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeZoom();
    });
    document.addEventListener('keydown', function handler(e) {
      if (e.key === 'Escape') { closeZoom(); document.removeEventListener('keydown', handler); }
    });
  }

  function closePane() {
    if (pane) pane.classList.remove('open');
    if (backdrop) backdrop.classList.remove('open');
    currentPaneHandle = null;
    currentPaneVariantId = null;
  }

  if (paneClose) paneClose.addEventListener('click', closePane);
  if (backdrop) backdrop.addEventListener('click', closePane);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && pane && pane.classList.contains('open')) closePane();
  });

  // === ADD TO CART FROM PANE ===
  if (paneAddBtn) {
    paneAddBtn.addEventListener('click', function() {
      if (!currentPaneVariantId || paneAddBtn.disabled) return;
      paneAddBtn.disabled = true;
      paneAddBtn.textContent = 'ADDING...';

      addToCart(currentPaneVariantId).then(function() {
        setPaneAdded();
        showPaneToast('Added to cart');

        // Remove this product's card from the carousel list.
        removeCardForVariant(currentPaneVariantId);

        // After a beat, suggest the next product that isn't in the cart yet.
        setTimeout(function() {
          suggestNext();
        }, 500);
      }).catch(function() {
        paneAddBtn.textContent = 'ERROR — RETRY';
        paneAddBtn.disabled = false;
        setTimeout(function() { paneAddBtn.textContent = 'ADD TO CART'; }, 2000);
      });
    });
  }

  function suggestNext() {
    // Find next products that aren't the current one and aren't already in the cart.
    var others = allPairProducts.filter(function(p) {
      return p.handle !== currentPaneHandle && !isInCart(p.variantId);
    });
    if (others.length === 0) return;

    var suggestDiv = document.createElement('div');
    suggestDiv.className = 'PairPane__Suggest';
    suggestDiv.innerHTML = '<div class="PairPane__SuggestLabel">Also pairs well</div>';
    others.forEach(function(p) {
      var item = document.createElement('div');
      item.className = 'PairPane__SuggestItem';
      item.setAttribute('data-suggest-handle', p.handle);
      item.innerHTML = (p.image ? '<img src="' + escapeHtml(p.image.replace('600x600', '100x100')) + '" alt="' + escapeHtml(p.title) + '">' : '') +
        '<span>' + escapeHtml(p.title) + '</span>';
      suggestDiv.appendChild(item);
    });

    // Append to body
    var existing = paneBody.querySelector('.PairPane__Suggest');
    if (existing) existing.remove();
    paneBody.appendChild(suggestDiv);

    // Scroll to bottom
    paneBody.scrollTop = paneBody.scrollHeight;

    // Click to open that product in pane
    suggestDiv.querySelectorAll('[data-suggest-handle]').forEach(function(item) {
      item.addEventListener('click', function() {
        openPane(item.getAttribute('data-suggest-handle'));
      });
    });
  }

  function showPaneToast(msg) {
    var toast = pane.querySelector('[data-pane-toast]');
    if (!toast) return;
    var span = toast.querySelector('span');
    if (span) span.textContent = msg;
    toast.classList.add('show');
    setTimeout(function() { toast.classList.remove('show'); }, 2500);
  }

  // === CART BAR ===
  function updateCartBar() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (cart.item_count > 0 && cartBar) {
          cartBar.classList.add('visible');
          var countEl = cartBar.querySelector('[data-pair-cart-count]');
          var totalEl = cartBar.querySelector('[data-pair-cart-total]');
          if (countEl) countEl.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
          if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
        }
        // Also update header cart count
        document.querySelectorAll('.js-cart-count, [data-cart-count], .Header__CartCount').forEach(function(el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function() {});
  }

  // === SHARED: Add to cart ===
  function addToCart(variantId) {
    var id = parseInt(variantId, 10);
    if (!id || isNaN(id)) return Promise.reject(new Error('Invalid variant'));
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('Failed');
      return r.json();
    })
    .then(function(data) {
      cartVariantIds[String(id)] = true;
      // Re-render the theme's mini-cart silently (updates item count + any
      // automatic discounts) WITHOUT popping the drawer open over the pane —
      // 'cart:refresh' re-renders only, 'product:added' would also open the drawer.
      // Must be dispatched on documentElement (that's where the theme delegates it).
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      updateCartBar();
      return data;
    });
  }

  // === HELPERS ===
  function formatMoney(cents) {
    if (!cents) return '';
    var amount = (parseInt(cents) / 100).toFixed(2);
    return '$' + amount;
  }

  function escapeHtml(str) {
    if (str === null || str === undefined) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

})();
